import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import { antdKoKRSunday } from "./utilities/weekLocale";
import { antdTheme } from "./theme";
import "./index.css";
import "./styles/modal-scroll-lock-fix.css";
import installModalScrollLockFix from "./utilities/installModalScrollLockFix";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import { register } from "./serviceWorkerRegistration";

installModalScrollLockFix();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<ConfigProvider locale={antdKoKRSunday} theme={antdTheme}>
			<App />
		</ConfigProvider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
register();
